import { useState, useEffect, useRef } from "react";
import "../assets/scss/custom/multiselect-typeahead.scss";

interface MultiSelectTypeahead {
  options: any;
  callback: (payload: any) => void;
  defaultValue?: any[];
  setSelectedItems?: (payload: any[]) => void;
  placeholder?: string;
  required?: boolean;
}

const MultiSelectTypeahead = (props: MultiSelectTypeahead) => {
  const [query, setQuery] = useState<any>("");
  const [suggestions, setSuggestions] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const containerRef = useRef<any>(null);

  useEffect(() => {
    setSuggestions(props.options);
    setIsLoading(false);
  }, [props.options]);
  useEffect(() => {
    if (query.length > 0) {
      setIsLoading(true);
      if (props.callback) {
        props.callback(query);
      }
    } else {
      setSuggestions([]);
    }
  }, [query]);
  useEffect(() => {
    if (props.defaultValue) {
      setSelectedItems(props.defaultValue);
    }
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputChange = (e: any) => {
    setQuery(e.target.value);
  };

  const handleSuggestionClick = (suggestion: any) => {
    if (!selectedItems.includes(suggestion)) {
      setSelectedItems([...selectedItems, suggestion]);
      if (props.setSelectedItems) {
        props.setSelectedItems([...selectedItems, suggestion]);
      }
    }
    setQuery("");
    setSuggestions([]);
  };

  const handleRemoveItem = (item: any) => {
    setSelectedItems(selectedItems.filter((i: any) => i !== item));
  };

  return (
    <div className="typeahead-container" ref={containerRef}>
      
      <div>
        <div className="search-box d-flex">
          <span className="material-symbols-outlined search-box__icon  ">
            search
          </span>
          <input
            className="form-control search-box__input fw-normal fs-12"
            type="text"
            value={query}
            onChange={handleInputChange}
            placeholder="Search..."
          />
        
        </div>
        <div className="selected-items mt-2">
        {suggestions.length === 0 && selectedItems.map((item: any, index: any) => (
          <div key={index} className="selected-item">
          {item.value ? item.value : item}
            <button onClick={() => handleRemoveItem(item)}>x</button>
          </div>
        ))}
      </div>
      </div>
      {isLoading && <div className="loading">Loading...</div>}
       {suggestions.length > 0 && (
        <ul className="suggestions-list">
         {suggestions.map((suggestion: any, index: any) => (
            <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
              {suggestion.value ? suggestion.value: suggestion }
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MultiSelectTypeahead;
